import React, { useState } from "react";
import Table from "../../stories/Table";
import { Link, navigate } from "@reach/router";
import { format } from "date-fns";
import { StatusTag } from "../../stories/StatusTag";
import { useStaffList } from "../../service/Fetchers";
import {
  getErrorData,
  getURLParams,
  getRoleNames,
  handleQuery,
} from "../../service/Helper";
import { DashboardView } from "../../stories/DashboardView";

const perPageCount = 10;

const ListStaff = () => {
  const currentPage = getURLParams("page") ?? 1;
  const searchQ = getURLParams("search") ?? "";

  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(currentPage);

  const { users, pageInfo, error, loading, isValidating, mutate } =
    useStaffList({
      currentPage: page,
      perPageCount,
      searchQuery: searchQ,
    });

  const loadingData = loading || isValidating;

  const headerData = {
    constructiveCTA: {
      link: "/dashboard/staff/add",
      title: "Add Staff",
    },
    states: [
      {
        title: "Staff List",
      },
    ],
    title: "List of staff",
    search: {
      show: true,
      searching: searchQuery.length && loadingData,
      placeholder: "Search using Staff ID or Name...",
      onSearch: (values) => {
        setPage(1);
        handleQuery(navigate, 1, values.query, "staff");
        setSearchQuery(values.query);
      },
      onChange: (values) => {
        if (!values.query) {
          setSearchQuery("");
        }
      },
    },
  };

  const content = (
    <Table
      headers={["Staff ID", "Staff Name", "Date Added", "Status", "Role"]}
      pagination={{
        currentpage: pageInfo?.current_page,
        itemsPerPage: pageInfo?.per_page,
        totalItems: pageInfo?.total_count,
        onPageChange: (page) => {
          handleQuery(navigate, page, searchQ, "staff");
        },
      }}
      loading={loadingData}
      rowContent={users.map((user) => [
        <p className="underline text-primary">
          <Link to={`/dashboard/staff/view/${user.id}`}>{user.uuid}</Link>
        </p>,
        <p>{`${user.first_name} ${user.last_name}`}</p>,
        <p>{format(new Date(user.created_at), "dd-MMM-yyyy")}</p>,
        <StatusTag type={user.deactivated ? "red" : "green"}>
          {user.deactivated ? "Deactivated" : "Active"}
        </StatusTag>,
        <p>{getRoleNames(user?.role.name)}</p>,
      ])}
    />
  );

  const errorData = getErrorData({
    error,
    searchQuery,
    data: users,
    mutate,
    title: "Staffs",
  });

  return (
    <DashboardView
      headerData={headerData}
      content={content}
      errorData={errorData}
      loading={loadingData}
      loadingContent={null}
    />
  );
};

export default ListStaff;
